window.onscroll = function() {
  if (window.innerWidth > 767) {
      scrollFunctionAbove767();
  } else {
      scrollFunctionBelow767();
  }
};


function scrollFunctionAbove767() {
  if (document.body.scrollTop > 110 || document.documentElement.scrollTop > 110) {
      document.getElementById("main-nav").style.padding = "15px 0px";
      document.getElementById("main-nav").style.borderBottom = "2px solid #90632C";
      document.getElementById("header-logo").style.bottom = "50%";
      document.getElementById("logo").style.width = "220px";
  } else {
      document.getElementById("main-nav").style.padding = "0px";
      document.getElementById("main-nav").style.borderBottom = "0px";
      document.getElementById("header-logo").style.bottom = "-30%";
      document.getElementById("logo").style.width = "260px";
  }
}


function scrollFunctionBelow767() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        //The Action
        document.getElementById("main-nav").style.borderBottom = "2px solid #90632C";
        document.getElementById("header-logo").style.bottom = "50%";
        document.getElementById("header-logo").style.textAlign = "left";
        document.getElementById("logo").style.width = "165px";
        document.getElementById("apply-btn").style.display = "none";
    } else {
        //The Default
        document.getElementById("main-nav").style.borderBottom = "0px";
        document.getElementById("header-logo").style.bottom = "-15%";
        document.getElementById("header-logo").style.textAlign = "center";
        document.getElementById("logo").style.width = "215px";
        document.getElementById("apply-btn").style.display = "block";
    }
}

/**
 * Active On: All Pages
 * Action: Main Menu Toggle On/Off
 * 
 */
document.addEventListener("DOMContentLoaded", function() {
    var toggle = document.querySelector('#js-toggle');
    if (toggle) {
        toggle.addEventListener('click', function() {
            this.classList.toggle('active');

            var overlay = document.querySelector('#js-overlay');
            overlay.classList.toggle('open');
        });
    }
});


/**
 * 
 * Active On: Floor Plans Page
 * Action: Toggle Availablity Table
 * 
 */
document.addEventListener("DOMContentLoaded", function() {
    const availToggle = document.querySelector('#js-avail-toggle');
    
    if (availToggle) {
        availToggle.addEventListener('click', function() {
            this.classList.toggle('active');
            
            const availMobile = document.querySelector('#js-availability-mobile');
            const availDesktop = document.querySelector('#js-availability-desktop');
            
            availMobile.classList.toggle('open');
            availDesktop.classList.toggle('open');
        });
    }
});

 /**
 * 
 * Active On: Neighborhood Page
 * Action: Control Map Legend Buttons
 * 
 */ 
/*
jQuery(document).ready(function($) {
    $('.js-map-cat-filter').click(function() {
        // Get the category ID from the clicked filter
        var categoryId = $(this).data('category'); 
        var checkboxId = 'wpgmza_cat_checkbox_' + categoryId;
        $('#' + checkboxId).click();

        //Add active class to the clicked filter button and remove from previously clicked button
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $('.js-map-cat-filter').removeClass('active');
            $(this).addClass('active');
        }
    });

    $('.wpgmza_checkbox').on('click', function() {
        $('.wpgmza_checkbox').not(this).prop('checked', false);
    });
});
*/

jQuery(document).ready(function($) {
    // Check the box with categoryId = 1 by default
    setTimeout(function() {
        var defaultCategoryId = 1;
        var defaultCheckboxId = 'wpgmza_cat_checkbox_' + defaultCategoryId;
        $('#' + defaultCheckboxId).click();
    }, 1000); // Adjust the delay time as needed

    $('.js-map-cat-filter').click(function() {
        // Get the category ID from the clicked filter
        var categoryId = $(this).data('category'); 
        var checkboxId = 'wpgmza_cat_checkbox_' + categoryId;
        $('#' + checkboxId).click();
    });

    $('.wpgmza_checkbox').on('click', function() {
        $('.wpgmza_checkbox').not(this).prop('checked', false);
    });
});


 /**
 * 
 * Active On: Floor Plans Page
 * Action: Only show the floor plan filter bar when the floor plan tab is active
 * 
 */
jQuery(document).ready(function($) {
    $('#floor-plan-tab').on('shown.bs.tab', function(e) {
        if($(this).hasClass('active')) {
            $('.filter-bar').addClass('open');
        }
    });
    //Close filter bar when floor plan tab is not active
    $('#floor-plan-tab').on('hidden.bs.tab', function(e) {
        $('.filter-bar').removeClass('open');
    });
});
